import alertService from './alert.service'

interface GeolocationCodrdinate {
  latitude: number
  longitude: number
}

type GeolocationAccessData = GeolocationCodrdinate | null

type GeolocationAccessCallback = (coordinate: GeolocationAccessData) => void

export default {
  access (callback: GeolocationAccessCallback) {
    try {
      window.navigator.geolocation.getCurrentPosition(position => {
        const { latitude, longitude } = position.coords
        const coordinate = { latitude, longitude }
        callback(coordinate)
      })
    } catch (error) {
      alertService.info('Unable to collect Geolocation')
    }
  }
}
